import React from 'react';
import T from 'prop-types';
// components
import Typography from 'components/Typography';
// icons
import { ReactComponent as TotalIcon } from 'icons/total-students.svg';
import { ReactComponent as FinishedIcon } from 'icons/students-finished.svg';
import { ReactComponent as ScoreIcon } from 'icons/average-score.svg';
// styles
import classnames from 'classnames/bind';
import styles from './OverviewBanner.module.scss';

const cx = classnames.bind(styles);

const OverviewBanner = ({ totalStudents = null, studentsFinished = null, overallScore = null, className }) => {
  return (
    <div className={cx('container', className)}>
      <div className={cx('wrapper', 'pdh-35')}>
        <div className={cx('element')}>
          <TotalIcon />
          <Typography className="mgh-10">Total Students: </Typography>
          <Typography className={cx('value')}>{totalStudents ?? '--'}</Typography>
        </div>
        <div className={cx('element')}>
          <FinishedIcon />
          <Typography className="mgh-10">Students Finished: </Typography>
          <Typography className={cx('value')}>
            {typeof studentsFinished === 'number' ? Math.round(studentsFinished) + '%' : '--'}
          </Typography>
        </div>
        <div className={cx('element')}>
          <ScoreIcon />
          <Typography className="mgh-10">Average Overall Score:</Typography>
          <Typography className={cx('value')}>
            {typeof overallScore === 'number' ? Math.round(overallScore) + '%' : '--'}
          </Typography>
        </div>
      </div>
    </div>
  );
};

OverviewBanner.propTypes = {
  totalStudents: T.number,
  studentsFinished: T.number,
  overallScore: T.number,
  className: T.oneOfType([T.func, T.string]),
};

export default OverviewBanner;
